"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _amb = _interopRequireDefault(require("./amb.Logger"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A listener for an amb channel
 * Returned from amb.getChannel. Client only interacts with cometd through this object.
 * @param channel - amb.Channel
 * @param serverConnection - amb.ServerConnection
 * @param subscriptionCallback - Callback to call on
 * @return amb.ChannelListener this listener
 */
var ChannelListener = function ChannelListener(channel, serverConnection, subscriptionCallback) {
  var id;
  var messageCallback;
  var LOGGER = new _amb.default('amb.ChannelListener');
  var currentChannel = channel;
  return {
    getCallback:
    /*Function*/
    function getCallback() {
      return messageCallback;
    },
    getSubscriptionCallback: function getSubscriptionCallback() {
      return subscriptionCallback;
    },
    getID:
    /*Integer*/
    function getID() {
      return id;
    },
    setNewChannel: function setNewChannel(channel) {
      currentChannel.unsubscribe(this);
      currentChannel = channel;
      this.subscribe(messageCallback);
    },

    /**
     * Register this listener with its channel.
     *
     * @return amb.ChannelListener this listener
     */
    subscribe:
    /*amb.ChannelListener*/
    function subscribe(
    /*Function*/
    callback) {
      messageCallback = callback;
      id = currentChannel.subscribe(this);
      return this;
    },
    resubscribe:
    /*amb.channelListener*/
    function resubscribe() {
      return this.subscribe(messageCallback);
    },

    /**
     * Unregister this listener from its channel.
     *
     * @return amb.ChannelListener this listener
     */
    unsubscribe:
    /*amb.ChannelListener*/
    function unsubscribe() {
      currentChannel.unsubscribe(this);
      LOGGER.debug("Unsubscribed from channel: " + currentChannel.getName());
      return this;
    },
    publish:
    /*void*/
    function publish(
    /*Hash*/
    message,
    /*Function*/
    callback) {
      currentChannel.publish(message, callback);
    },
    getName:
    /*String*/
    function getName() {
      return currentChannel.getName();
    }
  };
};

var _default = ChannelListener;
exports.default = _default;